import './system.css';

/**
 * Shared error state for surfaces that failed to load. Never render a raw
 * error object here — callers pass human copy; the caught error itself
 * should only ever go to console.error.
 * @param {{ title: string, detail?: string, onRetry?: () => void }} props
 */
function ErrorState({ title, detail, onRetry }) {
  return (
    <div className="sys-error" role="alert">
      <h2 className="sys-error-title">{title}</h2>
      {detail && <p className="sys-error-detail">{detail}</p>}
      {onRetry && (
        <div className="sys-error-actions">
          <button type="button" className="sys-cta sys-cta-primary" onClick={onRetry}>
            Try again
          </button>
        </div>
      )}
    </div>
  );
}

export default ErrorState;
